// src/app/pages/endorsements/endorsements.component.ts

import { Component, OnInit } from '@angular/core';

import { CommonModule } from '@angular/common';

import { RouterModule } from '@angular/router';

import { SeoService } from '../../services/seo.service';

export interface Endorsement {
  name: string;
  title: string;
  quote?: string;
  photo?: string;
}

export interface EndorsementCategory {
  label: string;
  icon: string;
  endorsements: Endorsement[];
}

@Component({
  selector: 'app-endorsements',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './endorsements.component.html',
  styleUrls: ['./endorsements.component.css'],
})
export class EndorsementsComponent implements OnInit {

  private readonly baseUrl =
    'https://www.lydialynnchristensen.com';

  private readonly endorsementsPageId =
    `${this.baseUrl}/endorsements#endorsements`;

  private readonly endorsementListId =
    `${this.baseUrl}/endorsements#endorsement-list`;

  constructor(private seo: SeoService) {}

  ngOnInit(): void {
    this.seo.update(
      'Endorsements',
      'See who is endorsing Lydia Christensen for U.S. Senate in Michigan 2026.',
      'endorsements'
    );

    this.seo.setStructuredData({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "CollectionPage",
          "@id": this.endorsementsPageId,
          "url": `${this.baseUrl}/endorsements`,
          "name": "Lydia Christensen Endorsements",
          "description": "Endorsements of Lydia Christensen for U.S. Senate in Michigan 2026.",
          "isPartOf": { "@id": this.seo.websiteId },
          "about": { "@id": this.seo.lydiaId },
          "publisher": { "@id": this.seo.campaignId },
          "mainEntity": { "@id": this.endorsementListId },
          "inLanguage": "en-US"
        },
        {
          "@type": "ItemList",
          "@id": this.endorsementListId,
          "name": "Lydia Christensen Endorsements",
          "numberOfItems": this.categories
            .reduce(
              (total, category) =>
                total + category.endorsements.length,
              0
            ),
          "itemListElement": this.categories
            .flatMap(category => category.endorsements)
            .map((endorsement, index) => ({
              "@type": "ListItem",
              "position": index + 1,
              "name": endorsement.name
            }))
        }
      ]
    });
  }

  categories: EndorsementCategory[] = [
    {
      label: 'Elected Officials',
      icon: '🏛️',
      endorsements: [
        // Add endorsements here.
      ],
    },

    {
      label: 'Community & Labor Leaders',
      icon: '✊',
      endorsements: [
        // Add endorsements here.
      ],
    },

    {
      label: 'Environmental & Advocacy Organizations',
      icon: '🌿',
      endorsements: [
        // Add endorsements here.
      ],
    },

    {
      label: 'Business & Tech Leaders',
      icon: '💼',
      endorsements: [
        // Add endorsements here.
      ],
    },

    {
      label: 'Educators & Health Professionals',
      icon: '🎓',
      endorsements: [
        // Add endorsements here.
      ],
    },
  ];

  get filledCategories(): EndorsementCategory[] {
    return this.categories.filter(c => c.endorsements.length > 0);
  }

  get hasAny(): boolean {
    return this.filledCategories.length > 0;
  }
}